import React, { useEffect, useRef, useState } from 'react';
import './SLP.style.scss';
import { useHistory, useParams } from 'react-router-dom';
import {
    FormShowType,
    ReduxState,
    Question,
    AnswerItem,
    AnswerStatus,
    ViewApi,
    QuestionTypes,
    QuestionValidationTypes,
    FormDetail,
    PrevFormDetail,
    Answer,
    Publish,
    Response,
} from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import { post } from 'scripts/api';
import { __Location, __SLPProps } from './SLP.interface';
import { Spinner } from 'react-bootstrap';
import SLPStartPage from '../../../SLP/startPage/startPage.index';
import SLPEndPage from '../../../SLP/endPage/endPage.index';
import SLPLayout, { SLPLayoutRef } from '../../../SLP/SLPLayout/SLPLayout.index';
// import SLPFooter from '../../SLP/footer/footer.index';
import SLPWizard from '../../../SLP/wizard/wizard.index';
import { API, RoutePath } from 'data';
import { toast } from 'react-toastify';
import { getDBPublish, getPublishAnswersCount, setPublishAnswers } from 'scripts/db';
import { detailForm2PreForm, setInitialAnswerList, SLPLogicalRelationship } from 'ucheck/SLP/SLP.script';
import { __AnswerApiErrType, __ViewApiErrType } from 'ucheck/SLP/SLP.interface';
import { answerErrToast, viewErrMessage } from 'ucheck/SLP/SLP.data';
import useWinEventListener from 'scripts/useWinEventListener';

const SLPContainer: React.FC<ConnectedProps<typeof connector> & __SLPProps> = function (
    props: ConnectedProps<typeof connector> & __SLPProps,
) {
    const { publish, form } = useParams<any>();
    const answer = useRef<Answer>();
    const [formDetail, setFormDetail] = useState<FormDetail>();
    const [step, setStep] = useState<'start' | 'end' | number>();
    const [wizardIndex, setWizardIndex] = useState<number>(0);
    const qRefs = useRef<SLPLayoutRef[]>([]);
    const [answerList, setAnswerList] = useState<AnswerItem[]>([]);
    const questionBox = useRef<HTMLDivElement[]>([]);
    const history = useHistory();
    const lang = props.lang.publishDetail;
    const [initialForm, setInitialForm] = useState<PrevFormDetail>();
    const view = useRef('');
    const [publishData, setPublishData] = useState<Publish>();
    const [answerCount, setAnswerCount] = useState<number | null>(null);
    const [errMsg, setErrMsg] = useState<string[]>();
    const answerToken = useRef<string>();
    const [questions, setQuestion] = useState<Question[][]>([[]]);
    const numericalStep = step !== 'start' && step !== 'end' && step !== undefined ? step : undefined;
    const autoNextFlag = useRef<boolean>(false);
    const startClicked = useRef<boolean>(false);
    let currentQuestion: Question | undefined = undefined;
    if (
        formDetail?.show_type === FormShowType.single &&
        numericalStep !== undefined &&
        questions[numericalStep] &&
        questions[numericalStep][wizardIndex]
    ) {
        currentQuestion = questions[numericalStep][wizardIndex];
    } else if (
        numericalStep !== undefined &&
        questions[numericalStep] &&
        questions[numericalStep].length &&
        questions[numericalStep][questions[numericalStep].length - 1]
    ) {
        currentQuestion = questions[numericalStep][questions[numericalStep].length - 1];
    }

    useEffect(() => {
        onInit();
        return () => {
            if (answer.current) {
                setPublishAnswers([answer.current], answer.current.questionerOffline ? 1 : 0);
            }
        };
    }, []);

    useEffect(() => {
        if (props.goback) {
            props.setGoback();
            history.replace(RoutePath.dashboard.answerList(publish, form));
        }
    }, [props.goback]);

    useEffect(() => {
        if (formDetail) {
            if (!formDetail.hide_start_page && step === 'start') onNext();
            else if (formDetail.hide_start_page && step === undefined) setStep(0);
        }
    }, [formDetail]);

    useEffect(() => {
        if (initialForm !== undefined && initialForm.hide_start_page && formDetail === undefined && step === undefined)
            onStart();
    }, [initialForm]);

    useEffect(() => {
        if (step === 'start' && questions.length && questions[0].length && startClicked.current) {
            startClicked.current = false;
            onNext();
        }
    }, [questions]);

    useWinEventListener('keydown', (e: KeyboardEvent) => {
        if (e.key === 'Tab') {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            onNext();
        }
    });

    function onInit() {
        answer.current = undefined;
        setWizardIndex(0);
        setStep(undefined);
        setAnswerList([]);
        setFormDetail(undefined);
        setInitialForm(undefined);
        // onStart();
        // if (!formDetail) return;
        getPublishAnswersCount(Number(publish)).then((answerCount) => {
            setAnswerCount(answerCount);
        });
        return new Promise((resolve) => {
            getDBPublish(Number(publish)).then((publishData) => {
                if (!publishData) {
                    resolve(false);
                    return;
                }
                setPublishData(publishData);
                post<ViewApi>(API.answers.addView, { publish })
                    .then((res) => {
                        if (res.data.view_id) {
                            setInitialForm(res.data.form);
                            view.current = res.data.view_id.toString();
                            console.log('LOG SET STEP START 1');

                            if (!res.data.form.hide_start_page) setStep('start');
                        }
                    })
                    .catch((res: Response<__ViewApiErrType>) => {
                        console.log(res);
                        if (res.status >= 500) toast.error(props.lang.serverErr);
                        else if (res.status >= 400)
                            setErrMsg(viewErrMessage(res.data.non_field_errors.map((i) => i.code)));
                        else {
                            // offline
                            view.current = '0';
                            console.log('LOG SET STEP START 2');
                            setInitialForm(detailForm2PreForm(publishData.form));
                            if (!publishData.form.hide_start_page) setStep('start');
                        }
                    })
                    .finally(() => resolve(true));
            });
        });
    }

    function onStart(pass?: string) {
        if (!initialForm || view.current.length === 0) return;
        return new Promise((resolve) => {
            startClicked.current = true;
            const params: any = {
                view: view.current,
            };
            if (pass) params.password = pass;
            const createdAt = new Date().toISOString();
            post<Answer>(API.answers.addAnswer, params)
                .then((res) => {
                    // online status
                    answerToken.current = res.data.access_token;
                    onNext();
                    setFormDetail(res.data.form);
                    setAnswerList(setInitialAnswerList([], currentQuestion?.id, res.data.form));
                    answer.current = {
                        access_token: res.data.access_token,
                        items: [],
                        created_at: createdAt,
                        modified_at: createdAt,
                        state: AnswerStatus.incomplete,
                        form: res.data.form,
                        id: res.data.id,
                        questionerOffline: false,
                        publish: Number(publish),
                    };
                })
                .catch((res: Response<__AnswerApiErrType>) => {
                    if (res.status >= 500) toast.error(props.lang.serverErr);
                    else if (view.current.length && view.current !== '0' && res.status >= 400)
                        answerErrToast(res.data.non_field_errors.map((i) => i.code));
                    else {
                        if (pass) toast.error(lang.noInternet);
                        else {
                            toast.warning(lang.offlineStatus);
                            // handleOffline
                            getDBPublish(Number(publish)).then((res) => {
                                const form = res?.form;
                                if (!form) return;
                                setFormDetail(form);
                                const id = new Date().getTime();
                                setAnswerList(setInitialAnswerList([], currentQuestion?.id, form));
                                const newAnswer: Answer = {
                                    id,
                                    items: [],
                                    form,
                                    created_at: createdAt,
                                    modified_at: createdAt,
                                    questionerOffline: true,
                                    state: AnswerStatus.incomplete,
                                    publish: Number(publish),
                                };
                                answer.current = newAnswer;
                                onNext();
                            });
                        }
                    }
                })
                .finally(() => {
                    resolve(true);
                    if (initialForm.ask_gps) {
                        console.log('asking gps', Boolean(navigator.geolocation));
                        navigator.geolocation.getCurrentPosition(
                            function (position) {
                                console.log(position);
                                if (!answer.current?.questionerOffline && answerToken.current) {
                                    post(API.answers.setLatLng(answerToken.current), {
                                        lat: position.coords.latitude,
                                        lng: position.coords.longitude,
                                    });
                                } else if (answer.current) {
                                    answer.current.lat = position.coords.latitude;
                                    answer.current.lng = position.coords.longitude;
                                }
                            },
                            function (err) {
                                console.log('user canceled', err);
                                toast.error(
                                    err.PERMISSION_DENIED
                                        ? lang.GPSPermissionDenied
                                        : err.POSITION_UNAVAILABLE
                                        ? lang.GPSnotAvailable
                                        : lang.GPSFailed,
                                );
                            },
                        );
                    }
                });
        });
    }

    function submitAnswerItem(item: AnswerItem) {
        const answerItem: AnswerItem = {
            value: item.value,
            question_items: item.question_items,
            question: item.question,
            created_at: new Date().toISOString(),
            id: item.id,
            answer_files: item.answer_files,
        };
        const objApi: any = {
            value: item.value,
            answer: answer.current?.id,
            question: item.question.id,
            question_items: item.question_items?.map((i) => i.id),
            answer_files: item.answer_files?.map((i) => i.id),
        };
        function miniTitleGen(str: string) {
            if (str.length > 10) return str.substr(0, 7) + '...';
            else return str;
        }
        if (!answer.current?.questionerOffline) {
            if (answerToken.current)
                post<AnswerItem>(API.answers.answerItem(answerToken.current), objApi)
                    .then((res) => {
                        if (answer.current) {
                            answerItem.id = res.data.id;
                            const indexItem = answer.current.items.findIndex((i) => i.question.id === item.question.id);
                            if (indexItem === undefined || indexItem < 0) answer.current.items.push(answerItem);
                            else answer.current.items[indexItem] = answerItem;
                        }
                    })
                    .catch((res) => {
                        if (res.status >= 500) toast.error(props.lang.serverErr);
                        else {
                            const str =
                                'ثبت آنلاین پاسخ سوال " ' +
                                miniTitleGen(item.question.title) +
                                ' " با خطا مواجه شد. پاسخنامه شما به صورت آنلاین بوده و آفلاین ذخیره نمیگردد';
                            toast.error(str);
                        }
                    });
        } else {
            const indexItem = answer.current.items.findIndex((i) => i.question.id === item.question.id);
            if (indexItem === undefined || indexItem < 0) answer.current.items.push(answerItem);
            else answer.current.items[indexItem] = answerItem;
        }
    }

    function onEnd() {
        return new Promise((resolve) => {
            if (!answer.current) {
                resolve(true);
                return;
            }
            answer.current.end_date = new Date().toISOString();
            answer.current.state = AnswerStatus.complete;
            if (!answer.current.questionerOffline) {
                if (answerToken.current)
                    post(API.answers.closeAnswer(answerToken.current), {}).then(() => {
                        view.current = '';
                        resolve(true);
                    });
            }
            setPublishAnswers([answer.current], answer.current.questionerOffline ? 1 : 0);
            // console.log(publishAnswer.current, publishData.get());
        });
    }

    function onNext() {
        if (!formDetail || step === undefined) return;
        if (step === 'start' && questions.length && questions[0].length) {
            // start and go to questions
            setStep(0);
            setWizardIndex(0);
        } else if (step !== 'start' && step !== 'end' && formDetail.show_type === FormShowType.single) {
            // console.log(qRefs.current);
            if (qRefs.current[wizardIndex]?.validate(true)) {
                if (formDetail?.show_type === FormShowType.single) qRefs.current[wizardIndex]?.submit(false);
                if (wizardIndex < questions[step].length - 1) setWizardIndex(wizardIndex + 1);
                else {
                    setStep('end');
                    onEnd();
                    // .then(() => {
                    // console.log(formDetail.hide_end_page);
                    // if (formDetail.hide_end_page) onInit();
                    // else setStep('end');
                    // });
                }
            }
        } else if (step !== 'start' && step !== 'end' && formDetail.show_type === FormShowType.multiple) {
            let errorIndex: number | undefined = undefined;
            qRefs.current.forEach((question, index) => {
                if (!question.validate(true) && errorIndex === undefined) errorIndex = index;
            });
            if (errorIndex !== undefined) {
                questionBox.current[errorIndex].scrollIntoView();
            } else {
                qRefs.current.forEach((question, index) => {
                    question.submit(true);
                });
                if (step < questions.length - 1) {
                    setStep(step + 1);
                    setWizardIndex(0);
                } else {
                    setStep('end');
                    // if (formDetail.hide_end_page) onInit();
                    // else setStep('end');
                    onEnd();
                }
            }
        }
    }

    function onPrev(page?: boolean) {
        if (!formDetail || step === undefined) return;
        if (page && step !== 'start' && step !== 'end' && step > 0) {
            // go to previous page
            setStep(step - 1);
            setWizardIndex(0);
        } else if (
            step !== 'start' &&
            step !== 'end' &&
            wizardIndex > 0 &&
            formDetail.show_type === FormShowType.single
        ) {
            // go to previous question
            setWizardIndex(wizardIndex - 1);
        } else if (step !== 'start' && step !== 'end' && wizardIndex === 0 && step > 0) {
            // go to previous page
            setStep(step - 1);
            setWizardIndex(0);
        }
    }

    useEffect(() => {
        let ques: Question[][] = [];
        if (formDetail?.show_type === FormShowType.single) {
            const temp = SLPLogicalRelationship(
                formDetail,
                answerList,
                currentQuestion?.id,
                answer.current?.answerer_info,
            );
            ques = [[]];
            for (const list of temp) {
                ques = [[...ques[0], ...list.sort((a, b) => a.order - b.order)]];
            }
        } else if (formDetail) {
            const temp = SLPLogicalRelationship(
                formDetail,
                answerList,
                currentQuestion?.id,
                answer.current?.answerer_info,
            );
            ques = [];
            for (const list of temp) {
                if (list.length) ques.push([...list.sort((a, b) => a.order - b.order)]);
            }
        }
        setQuestion(ques);
    }, [formDetail, answerList, answer, wizardIndex, step]);

    function onSlideChange(e: number) {
        if (formDetail?.show_type === FormShowType.multiple) qRefs.current[wizardIndex]?.submit(false);
        setWizardIndex(e);
    }

    // auto next for some question types
    useEffect(() => {
        if (
            autoNextFlag.current &&
            formDetail?.show_type === FormShowType.single &&
            answerList.length > 0 &&
            step !== undefined &&
            step !== 'end' &&
            step !== 'start' &&
            wizardIndex < questions[step].length - 1
        ) {
            const question = questions[step][wizardIndex];
            const answerItem = answerList.find((item) => item.question.id === question.id);
            if (answerItem && wizardIndex < questions[step].length - 1) {
                if (
                    question.input_type === QuestionTypes.dropDown ||
                    question.input_type === QuestionTypes.twoOptions ||
                    question.input_type === QuestionTypes.nps ||
                    question.input_type === QuestionTypes.emoji ||
                    question.input_type === QuestionTypes.rate ||
                    (question.input_type === QuestionTypes.selective &&
                        !question.validations?.find((i) => i.title === QuestionValidationTypes.selective)?.value &&
                        answerItem.question_items?.length &&
                        answerItem.question_items[0].value !== '1') ||
                    (question.input_type === QuestionTypes.pictureSelective &&
                        !question.validations?.find((i) => i.title === QuestionValidationTypes.selective)?.value &&
                        answerItem.question_items?.length &&
                        answerItem.question_items[0].value !== '1')
                ) {
                    onNext();
                }
            }
        }
        if (autoNextFlag.current) autoNextFlag.current = false;
    }, [questions]);

    console.log(answerList);

    if (publishData?.quota && answerCount !== null && answerCount >= publishData.quota)
        return <div className="d-flex align-items-center justify-content-center">{lang.noQuota}</div>;

    // console.log(
    //     view.current.length === 0 && step !== 'end',
    //     !initialForm,
    //     answerCount === null,
    //     !publishData,
    //     !answer && initialForm?.hide_start_page,
    //     step === undefined,
    // );
    return (
        <div className={`ucheck-slp-higher-order`}>
            {errMsg ? (
                <div className="slp-no-view-box">
                    <div>
                        {errMsg.map((i) => (
                            <h4 key={i}>{i}</h4>
                        ))}
                    </div>
                </div>
            ) : (
                <div
                    style={{
                        background: initialForm?.background_image_file
                            ? 'url(' + initialForm?.background_image_file?.file + ')'
                            : initialForm?.background_color
                            ? initialForm.background_color
                            : undefined,
                    }}
                    className="slp-view-box"
                >
                    {initialForm && step === 'start' ? (
                        <SLPStartPage
                            next={(e) => {
                                return onStart(e);
                            }}
                            form={initialForm}
                        />
                    ) : null}
                    {formDetail
                        ? questions.map((section, sectionIndex) => {
                              if (step !== sectionIndex) return null;
                              let reInit = false;
                              if (qRefs.current.length !== section.length) {
                                  qRefs.current = [];
                                  reInit = true;
                              }
                              questionBox.current = [];
                              return (
                                  <SLPWizard
                                      className="slp-body"
                                      key={sectionIndex}
                                      questions={section}
                                      wizardIndex={wizardIndex}
                                      form={formDetail}
                                      onChange={onSlideChange}
                                      layout={(quiz, index) => (
                                          <div
                                              ref={(ref) => {
                                                  if (ref) questionBox.current.push(ref);
                                              }}
                                              key={quiz.id}
                                          >
                                              <SLPLayout
                                                  ref={(ref) => {
                                                      if (ref && reInit) qRefs.current.push(ref);
                                                      else if (ref) qRefs.current[index] = ref;
                                                  }}
                                                  key={index}
                                                  submit={submitAnswerItem}
                                                  form={formDetail}
                                                  questions={questions}
                                                  sectionIndex={sectionIndex}
                                                  questionIndex={index}
                                                  next={onNext}
                                                  previous={onPrev}
                                                  answerList={answerList}
                                                  setAnswerList={(answersList) => {
                                                      autoNextFlag.current = true;
                                                      setAnswerList(
                                                          setInitialAnswerList(
                                                              answersList,
                                                              currentQuestion?.id,
                                                              formDetail,
                                                          ),
                                                      );
                                                  }}
                                                  answer={answer.current}
                                                  cancel={onInit}
                                              />
                                          </div>
                                      )}
                                  />
                              );
                          })
                        : null}
                    {formDetail && step === 'end' ? <SLPEndPage startAgain={onInit} form={formDetail} /> : null}
                    {(view.current.length === 0 && step !== 'end') ||
                    !initialForm ||
                    answerCount === null ||
                    !publishData ||
                    (!answer && initialForm.hide_start_page) ||
                    step === undefined ? (
                        <div className="loading-content">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    ) : null}
                </div>
            )}
            {/* <SLPFooter
                form={formDetail}
                question={step !== 'start' && step !== 'end' ? questions[step][wizardIndex] : undefined}
                onNext={onNext}
                onPrev={onPrev}
                cover={props.footerCover}
            /> */}
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    lang: state.lang,
    direction: state.direction,
});

const connector = connect(mapStateToProps);
export default connector(SLPContainer);
